import request from "@/utils/request";
export const queryPage = "/icps/system/sign/basics/station/QueryPage";
export const batchUpdateOrDelete = "/icps/system/sign/basics/station/deletes";
export const saveOrUpdate = "/icps/system/sign/basics/station/saveOrUpdate";
export const updateSortNum = "";
export const Download = "/icps/system/sign/basics/station/exportStation";
export function querysitePage() {
  let data = {
    page: 1,
    pageSize: 999999,
  };
  return request({
    url: "/icps/system/sign/basics/station/QueryPage",
    method: "post",
    data,
  });
}
/*保存 */
export function saveOrUpdateStation(data) {
  return request({
    url: "/icps/system/sign/basics/station/saveOrUpdate",
    method: "post",
    data,
  });
}
/*获取地磅信息*/
export function getStationInfo(params) {
  return request({
    url: "/icps/noToken/getStationInfo",
    method: "get",
    params,
  });
}
/*生产线*/
export function saveOrUpdateProductLine(data) {
  return request({
    url: "/icps/system/sign/basics/station/saveOrUpdateProductLine",
    method: "post",
    data,
  });
}
export function getusewarehousearr(data) {
  return request({
    url: "/icps/system/sign/basics/station/queryListsByStationId ",
    method: "post",
    data,
  });
}
export function getPLByStationId(data) {
  return request({
    url: "/icps/system/sign/basics/station/getPLByStationId",
    method: "post",
    data,
  });
}
/*使用仓数据*/
export function wareusehousePage(data) {
  return request({
    url: "/icps/system/sign/basics/station/getListByStationId",
    method: "post",
    data,
  });
}
export function wareusehousesaveOrUpdate(data) {
  return request({
    url: "/icps/system/sign/basics/station/saveOrUpdateUseBank",
    method: "post",
    data,
  });
}
export function queryListsByStationId(data) {
  return request({
    url: "/icps/system/sign/basics/warehouse/getListByStationId",
    method: "post",
    data,
  });
}

/*库存仓数据*/
export function warehousePage(data) {
  return request({
    url: "/icps/system/sign/basics/warehouse/getListByStationId",
    method: "post",
    data,
  });
}
export function warehousesaveOrUpdate(data) {
  return request({
    url: "/icps/system/sign/basics/warehouse/saveOrUpdate",
    method: "post",
    data,
  });
}
/*浆水池维护*/
export function getListByPid(data) {
  return request({
    url: "/icps/system/sign/basics/seriflux/getListByPid",
    method: "post",
    data,
  });
}
export function saveseriflux(data) {
  return request({
    url: "/icps/system/sign/basics/seriflux/save",
    method: "post",
    data,
  });
}
/**查询编码是否存在 */
export function stationQueryCode(data) {
  return request({
    url: "/icps/system/sign/basics/station/QueryCode",
    method: "post",
    data,
  });
}

/**站点交货二维码 */
export function getStationWxacode(params) {
  return request({
    url: "/base/outer/no/login/getStationWxacode",
    method: "get",
    params,
  });
}

/**新增站点主体 */
export function addStationMain(data) {
  return request({
    url: "/icps/system/sign/basics/station/saveOrUpdateStationSubject",
    method: "post",
    data,
  });
}

/**站点主体列表 */
export function getStationMain(data) {
  return request({
    url: "/icps/system/sign/basics/station/getStationSubjectList",
    method: "post",
    data,
  });
}
/**获取使用仓库存仓绑定关系 */
export function queryWarehouseUse(data) {
  return request({
    url: "/icps/system/sign/basics/warehouse/queryWarehouseUse",
    method: "post",
    data,
  });
}
/**保存使用仓库存仓绑定关系 */
export function saveWarehouseUse(data) {
  return request({
    url: "/icps/system/sign/basics/warehouse/saveWarehouseUse",
    method: "post",
    data,
  });
}
/**更新使用仓库存仓绑定关系 */
export function updateWarehouseUse(data) {
  return request({
    url: "/icps/system/sign/basics/warehouse/updateWarehouseUse",
    method: "post",
    data,
  });
}
